import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const GoogleDriveLogoRightYellowIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg} focusable="false">
      <path d="M1995 1261h-646L699 128h646l650 1133z" />
    </svg>
  ),
  displayName: 'GoogleDriveLogoRightYellowIcon',
});

export default GoogleDriveLogoRightYellowIcon;
